import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { Sky } from "three/addons/objects/Sky.js";
import GUI from "lil-gui";
import CANNON from "cannon";

let colorButton;

const resetButton = document.querySelector("#reset");
const createSphereButton = document.querySelector("#addSphere");
const createBoxButton = document.querySelector("#addBox");

resetButton.addEventListener("click", () => {
  reset();
});
createBoxButton.addEventListener("click", () => {
  randomBox();
});
createSphereButton.addEventListener("click", () => {
  randomSphere();
});

/**
 * Debug
 */
const gui = new GUI();
gui.hide();

const randomBox = () => {
  createBox(Math.random(), Math.random(), Math.random(), {
    x: (Math.random() - 0.5) * 10,
    y: 3,
    z: (Math.random() - 0.5) * 10,
  });
  createBoxButton.style.backgroundColor = colorButton;
};

const randomSphere = () => {
  createSphere(Math.random(), {
    x: (Math.random() - 0.5) * 10,
    y: 3,
    z: (Math.random() - 0.5) * 10,
  });
  createSphereButton.style.backgroundColor = colorButton;
};

const reset = () => {
  for (const object of objectsToUpdate) {
    object.body.removeEventListener("collide", playHitSound);
    world.removeBody(object.body);
    scene.remove(object.mesh);
  }
  objectsToUpdate.length = 0;
  createSphere(0.5, { x: 0, y: 3, z: 0 });
  resetButton.style.backgroundColor = colorButton;
};

// Canvas
const canvas = document.querySelector("canvas.webgl");
// Scene
const scene = new THREE.Scene();

// Sound
const hitSound = new Audio("/sounds/hit.mp3");

const playHitSound = (collision) => {
  const impactVelocity = collision.contact.getImpactVelocityAlongNormal();
  const volume = Math.min(Math.max(impactVelocity / 10, 0.1), 1);

  if (impactVelocity > 1.5) {
    hitSound.volume = volume;
    hitSound.currentTime = 0;
    hitSound.play();
  }
};

// Physiscs

//World
const world = new CANNON.World();
world.broadphase = new CANNON.SAPBroadphase(world);
world.allowSleep = true;
world.gravity.set(0, -9.82, 0);

// Materials
const defaultMaterial = new CANNON.Material("default");

const defaultPlasticContactMaterial = new CANNON.ContactMaterial(
  defaultMaterial,
  defaultMaterial,
  {
    friction: 0.1,
    restitution: 0.7,
  }
);
world.addContactMaterial(defaultPlasticContactMaterial);
world.defaultContactMaterial = defaultPlasticContactMaterial;

// Floor
const floorShape = new CANNON.Plane();
const floorBody = new CANNON.Body();
floorBody.addShape(floorShape);
floorBody.quaternion.setFromAxisAngle(new CANNON.Vec3(-1, 0, 0), Math.PI * 0.5);
world.addBody(floorBody);

/**
 * Floor
 */
const floor = new THREE.Mesh(
  new THREE.PlaneGeometry(200, 200),
  new THREE.MeshStandardMaterial({
    color: "#ffffff",
    metalness: 0.3,
    roughness: 0.8,
    envMapIntensity: 0.5,
  })
);
floor.receiveShadow = true;
floor.rotation.x = -Math.PI * 0.5;
scene.add(floor);
/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
scene.add(ambientLight);

const directionalLight = new THREE.DirectionalLight(0xffffff, 2.5);
directionalLight.castShadow = true;
directionalLight.shadow.mapSize.set(1024 * 8, 1024 * 8);
directionalLight.shadow.camera.far = 50;
directionalLight.shadow.camera.left = -100;
directionalLight.shadow.camera.top = 100;
directionalLight.shadow.camera.right = 100;
directionalLight.shadow.camera.bottom = -100;
directionalLight.position.set(10, 30, 10);
scene.add(directionalLight);

gui.add(ambientLight, "intensity").min(0).max(10).step(0.001);
gui.add(directionalLight, "intensity").min(0).max(10).step(0.001);

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.1,
  100
);
camera.position.set(-5, 5, 3);
gui.add(camera.position, "x").min(-10).max(10).step(0.01);
gui.add(camera.position, "y").min(-10).max(10).step(0.01);
gui.add(camera.position, "z").min(-10).max(10).step(0.01);
scene.add(camera);

// Controls
const controls = new OrbitControls(camera, canvas);
controls.enablePan = false;
controls.enableDamping = true;
controls.maxPolarAngle = 1.5;
controls.minDistance = 3;
controls.maxDistance = 20;

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
});
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

// Sky
let sky = new Sky();
sky.scale.setScalar(450000);
scene.add(sky);

let sun = new THREE.Vector3();

scene.add(sky);

const effectController = {
  turbidity: 10,
  rayleigh: 0.323,
  mieCoefficient: 0,
  mieDirectionalG: 0.35,
  elevation: 10,
  azimuth: 180,
  exposure: renderer.toneMappingExposure,
};
function guiChanged() {
  const uniforms = sky.material.uniforms;
  uniforms["turbidity"].value = effectController.turbidity;
  uniforms["rayleigh"].value = effectController.rayleigh;
  uniforms["mieCoefficient"].value = effectController.mieCoefficient;
  uniforms["mieDirectionalG"].value = effectController.mieDirectionalG;

  const phi = THREE.MathUtils.degToRad(90 - effectController.elevation);
  const theta = THREE.MathUtils.degToRad(effectController.azimuth);

  sun.setFromSphericalCoords(1, phi, theta);

  uniforms["sunPosition"].value.copy(sun);

  renderer.toneMappingExposure = effectController.exposure;
  renderer.render(scene, camera);
}

const skyFolder = gui.addFolder("Sky");

skyFolder
  .add(effectController, "turbidity", 0.0, 20.0, 0.1)
  .onChange(guiChanged);
skyFolder.add(effectController, "rayleigh", 0.0, 4, 0.001).onChange(guiChanged);
skyFolder
  .add(effectController, "mieCoefficient", 0.0, 0.1, 0.001)
  .onChange(guiChanged);
skyFolder
  .add(effectController, "mieDirectionalG", 0.0, 1, 0.001)
  .onChange(guiChanged);
skyFolder.add(effectController, "elevation", 0, 90, 0.1).onChange(guiChanged);
skyFolder.add(effectController, "azimuth", -180, 180, 0.1).onChange(guiChanged);
skyFolder.add(effectController, "exposure", 0, 1, 0.0001).onChange(guiChanged);
guiChanged();

// Utils

const createRandomMaterial = () => {
  const color = new THREE.Color(Math.random(), Math.random(), Math.random());
  const roughness = Math.random() * (0.8 - 0.4) + 0.4; // Valor aleatorio entre 0.4 y 0.8
  const metalness = Math.random() * (0.8 - 0.4) + 0.4; // Valor aleatorio entre 0.4 y 0.8
  colorButton = "#" + color.getHexString();
  return new THREE.MeshStandardMaterial({
    color: color,
    roughness: roughness,
    metalness: metalness,
    envMapIntensity: 0.5,
  });
};

const SphereGeometry = new THREE.SphereGeometry(1, 32, 32);
const objectsToUpdate = [];
let interactiveObjects = [];

const createSphere = (radius, position) => {
  // Three.js
  const material = createRandomMaterial(); // Usar la función para crear un material aleatorio
  const mesh = new THREE.Mesh(SphereGeometry, material);
  mesh.scale.set(radius, radius, radius);
  mesh.castShadow = true;
  mesh.position.copy(position);
  scene.add(mesh);

  // Cannon.js
  const shape = new CANNON.Sphere(radius);
  const body = new CANNON.Body({
    mass: 1,
    position: new CANNON.Vec3(position.x, position.y, position.z),
    shape,
    material: defaultMaterial,
  });
  body.addEventListener("collide", playHitSound);
  world.addBody(body);

  // Save in objects to update
  objectsToUpdate.push({
    mesh,
    body,
  });
  interactiveObjects = objectsToUpdate.map((obj) => obj.mesh);
};

createSphere(0.5, { x: 0, y: 3, z: 0 });

const BoxGeometry = new THREE.BoxGeometry(1, 1, 1);

const createBox = (width, height, depth, position) => {
  // Three.js
  const material = createRandomMaterial(); // Usar la función para crear un material aleatorio
  const mesh = new THREE.Mesh(BoxGeometry, material);
  mesh.scale.set(width, height, depth);
  mesh.castShadow = true;
  mesh.position.copy(position);
  scene.add(mesh);

  // Cannon.js
  const shape = new CANNON.Box(
    new CANNON.Vec3(width / 2, height / 2, depth / 2)
  );
  const body = new CANNON.Body({
    mass: 1,
    position: new CANNON.Vec3(position.x, position.y, position.z),
    shape,
    material: defaultMaterial,
  });
  body.addEventListener("collide", playHitSound);
  world.addBody(body);
  objectsToUpdate.push({
    mesh,
    body,
  });
  interactiveObjects = objectsToUpdate.map((obj) => obj.mesh);
};

// Interact with the scene
const raycaster = new THREE.Raycaster();
const mouse = new THREE.Vector2();
let jointConstraint = null;
let intersects = [];
let isDragging = false;

// Joint body, to later constraint the cube
const jointShape = new CANNON.Sphere(0.1);
const jointBody = new CANNON.Body({ mass: 0 });
jointBody.addShape(jointShape);
jointBody.collisionFilterGroup = 0;
jointBody.collisionFilterMask = 0;
world.addBody(jointBody);

// Click marker to be shown on interaction
const markerGeometry = new THREE.SphereGeometry(0.2, 8, 8);
const markerMaterial = new THREE.MeshLambertMaterial({ color: 0xff0000 });
const clickMarker = new THREE.Mesh(markerGeometry, markerMaterial);
clickMarker.visible = false; // Hide it..
scene.add(clickMarker);

// Movement plane when dragging
const planeGeometry = new THREE.PlaneGeometry(100, 100);
let movementPlane = new THREE.Mesh(
  planeGeometry,
  new THREE.MeshLambertMaterial({ color: 0x777777 })
);
movementPlane.visible = false; // Hide it..
scene.add(movementPlane);

function onMouseDown(event) {
  event.preventDefault();

  // Actualizar el raycaster con la posición del mouse
  mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
  mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
  raycaster.setFromCamera(mouse, camera);

  // Intersectar objetos con el raycaster
  intersects = raycaster.intersectObjects(interactiveObjects);

  // Salir si no se intersecta ningún objeto
  if (intersects.length === 0) {
    return;
  }

  // Obtener el punto de intersección con el objeto seleccionado
  const hitPoint = getHitPoint(
    event.clientX,
    event.clientY,
    intersects[0].object,
    camera
  );

  // Salir si no hay un punto de intersección válido
  if (!hitPoint) {
    return;
  }

  // Desactivar controles de órbita y mostrar marcador de clic
  controls.enabled = false;
  showClickMarker();
  moveClickMarker(hitPoint);

  // Mover plano de movimiento y añadir restricción de joint
  moveMovementPlane(hitPoint, camera);
  const cubeBody = objectsToUpdate.find(
    (obj) => obj.mesh === intersects[0].object
  ).body;
  addJointConstraint(hitPoint, cubeBody);

  // Marcar que se está arrastrando
  requestAnimationFrame(() => {
    isDragging = true;
  });
}

function onMouseMove(event) {
  event.preventDefault();
  if (!isDragging) {
    return;
  }
  const hitPoint = getHitPoint(
    event.clientX,
    event.clientY,
    movementPlane,
    camera
  );

  if (hitPoint) {
    moveClickMarker(hitPoint);
    moveJoint(hitPoint);
  }
}

function onMouseUp(event) {
  event.preventDefault();

  isDragging = false;
  hideClickMarker();

  removeJointConstraint();
  controls.enabled = true;
}

canvas.addEventListener("pointerdown", onMouseDown, false);
canvas.addEventListener("pointermove", onMouseMove, false);
canvas.addEventListener("pointerup", onMouseUp, false);

// Añadir eventos de touch equivalentes para soporte móvil
canvas.addEventListener("touchstart", onMouseDown, false);
canvas.addEventListener("touchmove", onMouseMove, false);
canvas.addEventListener("touchend", onMouseUp, false);

// This function moves the virtual movement plane for the mouseJoint to move in
function moveMovementPlane(point, camera) {
  // Center at mouse position
  movementPlane.position.copy(point);

  // Make it face toward the camera
  movementPlane.quaternion.copy(camera.quaternion);
}

// Returns an hit point if there's a hit with the mesh,
// otherwise returns undefined
function getHitPoint(clientX, clientY, mesh, camera) {
  // Get 3D point form the client x y
  const mouse = new THREE.Vector2();
  mouse.x = (clientX / window.innerWidth) * 2 - 1;
  mouse.y = -((clientY / window.innerHeight) * 2 - 1);

  // Get the picking ray from the point
  raycaster.setFromCamera(mouse, camera);

  // Find out if there's a hit
  const hits = raycaster.intersectObject(mesh);

  // Return the closest hit or undefined
  return hits.length > 0 ? hits[0].point : undefined;
}

// Add a constraint between the cube and the jointBody
// in the initeraction position
function addJointConstraint(position, constrainedBody) {
  // Vector that goes from the body to the clicked point
  const vector = new CANNON.Vec3()
    .copy(position)
    .vsub(constrainedBody.position);

  // Apply anti-quaternion to vector to tranform it into the local body coordinate system
  const antiRotation = constrainedBody.quaternion.inverse();
  const pivot = antiRotation.vmult(vector); // pivot is not in local body coordinates

  // Move the cannon click marker body to the click position
  jointBody.position.copy(position);

  // Create a new constraint
  // The pivot for the jointBody is zero
  jointConstraint = new CANNON.PointToPointConstraint(
    constrainedBody,
    pivot,
    jointBody,
    new CANNON.Vec3(0, 0, 0)
  );

  // Add the constraint to world
  world.addConstraint(jointConstraint);
}

// This functions moves the joint body to a new postion in space
// and updates the constraint
function moveJoint(position) {
  jointBody.position.copy(position);
  jointConstraint.update();
}

// Remove constraint from world
function removeJointConstraint() {
  if (jointConstraint) {
    world.removeConstraint(jointConstraint);
    jointConstraint = null;
  }
}

function showClickMarker() {
  clickMarker.visible = true;
}

function moveClickMarker(position) {
  clickMarker.position.copy(position);
}

function hideClickMarker() {
  clickMarker.visible = false;
}

/**
 * Animate
 */
const clock = new THREE.Clock();
let oldElapsedTime = 0;

const tick = () => {
  const elapsedTime = clock.getElapsedTime();
  const deltaTime = elapsedTime - oldElapsedTime;
  oldElapsedTime = elapsedTime;

  // Update physics
  world.step(1 / 60, deltaTime, 3);

  for (const object of objectsToUpdate) {
    object.mesh.position.copy(object.body.position);
    object.mesh.quaternion.copy(object.body.quaternion);
  }

  // Update controls
  controls.update();

  // Render
  renderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();
